module.exports = __webpack_public_path__ + "h5/img/live-logo.60e27853.gif";